import {
  GameCategoryInfo,
  GameCategoryType,
} from "./gameCategory";

function getValueByPath(source: Record<string, any> | undefined, path?: string) {
  if (!source || !path) {
    return undefined;
  }

  return path.split(".").reduce((current, key) => current?.[key], source);
}

export function filterCategoriesByGameList(
  categories: GameCategoryInfo[],
  lobbyData?: Record<string, any>
): GameCategoryInfo[] {
  return categories.filter((category) => {
    if (!category.dataKey) {
      return true;
    }

    const gameList = getValueByPath(lobbyData, category.dataKey);
    return Array.isArray(gameList) && gameList.length > 0;
  });
}

export function selectVisibleCategories(
  categories: GameCategoryInfo[],
  options: {
    isLogin: boolean;
    excludeFavorite?: boolean;
    omitFirst?: boolean;
  }
): GameCategoryInfo[] {
  const { isLogin, excludeFavorite = false, omitFirst = false } = options;

  const visibleCategories = categories
    .filter((category) => {
      if (category.enabled === false || category.ignore) {
        return false;
      }

      if (excludeFavorite && category.type === GameCategoryType.FAVORITE) {
        return false;
      }

      if (category.auth && !isLogin) {
        return false;
      }

      return true;
    });

  return omitFirst ? visibleCategories.slice(1) : visibleCategories;
}
